module.exports = "/_next/static/images/AnalyticsAcademy-d38672c7922a81a5e400ff946a2681c2.png";